/*
 •
ar Arabic
•
cs Czech
•
da Danish
•
de German
•
en English
•
es Spanish
•
fi Finnish
•
fr French
•
hi Hindi
•
it Italian
•
ja Japanese
•
nb Norwegian
•
nl Dutch
•
pl Polish
•
pt Portuguese
•
* */


export enum LngKeys {
  EN = 'en', // English – United States, United Kingdom, Canada, Australia, Ireland, New Zealand
  // FR = 'fr', // French – France, Belgium, Switzerland, Canada (Quebec), Luxembourg, African Countries
  // DE = 'de', // German – Germany, Austria, Switzerland, Liechtenstein
  // ES = 'es', // Spanish – Spain, Mexico, Argentina, Colombia, Chile, Peru
  // SV = 'sv', // Swedish – Sweden, Finland
  // PT = 'pt', // Portuguese – Portugal, Brazil, Angola, Mozambique
  // IT = 'it', // Italian – Italy, Switzerland, San Marino
  // NB = 'nb', // Norwegian (Bokmål) – Norway
  // NL = 'nl', // Dutch – Netherlands, Belgium
  // FI = 'fi', // Finnish – Finland
  // CS = 'cs', // Czech – Czech Republic
  // PL = 'pl', // Polish – Poland
  // DA = 'da', // Danish – Denmark
  // EL = 'el', // Greek
  // RO = 'ro', // Romanian

  RU = 'ru', // Russian – Russia, Belarus, Kazakhstan, Kyrgyzstan, Ukraine
  // HI = 'hi', // Hindi – India
  // TR = 'tr', // Turkish – Turkey
  // ZH = 'zh', // Chinese – China, Taiwan, Singapore
  // JA = 'ja', // Japanese – Japan
  // AR = 'ar', // Arabic – Saudi Arabia, UAE, Egypt, Jordan, Morocco
}

